import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { BaseBackResponse } from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/trackingReferences`;

export interface AddExternalCarrierTrackingReferenceCommandPayload {
  fileId: string;
  moduleDefinitionId?: string;
  moduleInstanceId?: string;
  carrierName?: string;
  trackingNumber?: string;
  unknownCarrier?: string;
  handlingDirection?: string;
  trackingUrl?: string;
}

export const addExternalCarrierTrackingReferenceRequest = ({
  fileId,
  moduleDefinitionId,
  moduleInstanceId,
  carrierName,
  trackingNumber,
  unknownCarrier,
  handlingDirection,
  trackingUrl,
}: AddExternalCarrierTrackingReferenceCommandPayload): ApiRequestDescriptor => {
  const json = unknownCarrier
    ? {
        moduleDefinitionId,
        moduleInstanceId,
        carrier: carrierName,
        trackingNumber,
        trackingUrl,
        handlingDirection,
        unknownCarrierName: unknownCarrier,
      }
    : {
        moduleDefinitionId,
        moduleInstanceId,
        carrier: carrierName,
        trackingNumber,
        handlingDirection,
      };

  return {
    url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
    config: { method: SUPPORTED_METHODS.POST, json },
  };
};

async function addExternalCarrierTrackingReferenceCommand(
  payload: AddExternalCarrierTrackingReferenceCommandPayload,
): Promise<BaseBackResponse> {
  try {
    return await executeQuery<BaseBackResponse>(
      addExternalCarrierTrackingReferenceRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default addExternalCarrierTrackingReferenceCommand;
